<template>
<div>
    <prescriptionWindow :textP="presText" v-if="showPres" @CloseBox="showPres=false"></prescriptionWindow>
    <sendDocMessage v-if="messagingOrderModel" @CloseBox="messagingOrderModel=false" @submitMessage="submitMessage"></sendDocMessage>
    <showImageBox v-if="ImageBox" @CloseBox="ImageBox=false" :id="imageUploadId" @showSuccessUpload="showSuccessUpload" @submitMessage="submitMessage"></showImageBox>
    <tostWindow :message="toastMessage" v-if="showT" />
    <div class="portal-tab-div" v-if="!isLoading">
        <div class="tab-headers-div">
            <div class="text-block-929">Order &amp; Status Updates</div>
            <div class="text-block-1045">Use this page to check the status of all your prescriptions &amp; supplements</div>
        </div>

        <progressItems :progressItems="progressItems" @showModel="showModel" @showModelMessage="showModelMessage" @showImageUpload="showImageUpload" v-if="progressItems.length"></progressItems>
        <div v-else>
            <p class="text-block-1045">You don't have any orders yet. <a href="/weight-loss-plan">Click here to get started.</a></p>
        </div>

        <div class="recommended-div">
            <div class="tab-headers-div">
                <div class="text-block-929">Recommended Therapies</div>
            </div>
            <div class="recos-div">
                <div class="reco-box-div">
                    <div class="portal-reco-box">
                        <div class="reco-top-labes">
                            <div class="reco-type-div"><img loading="lazy" src="@/assets/images/icon_-RX-black.svg" alt="" class="reco-type-icon">
                                <div class="text-block-790">Prescricption</div>
                            </div>
                            <div class="reco-category">WEIGHT LOSS</div>
                        </div>
                        <div class="reco-top-summary">
                            <div class="reco-pic-name-div"><img sizes="100vw" srcset="@/assets/images/Tirzepatide-Vial-p-500.png 500w, @/assets/images/Tirzepatide-Vial-p-800.png 800w, @/assets/images/Tirzepatide-Vial.png 1080w" alt="" src="@/assets/images/Tirzepatide-Vial.png" loading="lazy" class="image-443">
                                <div class="reco-name">
                                    <div class="text-block-932">Tirzepatide</div>
                                    <div class="text-block-933">Compound</div>
                                </div>
                            </div>
                            <div class="reco-price-div">
                                <div class="amount-div">
                                    <div class="text-block-934">$</div>
                                    <div class="text-block-935">449</div>
                                </div>
                                <div class="text-block-936">a month</div>
                            </div>
                        </div>
                        <div class="reco-list-div">
                            <div class="reco-list-header">How it could help:</div>
                            <ul role="list" class="list-3">
                                <li>
                                    <div class="reco-list-text">Lose up to 20% body weight in 90 days or less</div>
                                </li>
                                <li>
                                    <div class="reco-list-text">Improve sleep cycle &amp; reduce apnea symptoms</div>
                                </li>
                                <li>
                                    <div class="reco-list-text">Boost daily energy patterns and activity levels</div>
                                </li>
                                <li>
                                    <div class="reco-list-text">Lower blood sugar and cholesterol</div>
                                </li>
                            </ul>
                        </div>
                        <div class="reco-box-bottom-div">
                            <div class="reco-buttons-div">
                                <a href="#" class="reco-button w-button">Learn More</a>
                                <a href="#" class="button-81 w-button">Add to Cart</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="reco-box-div">
                    <div class="portal-reco-box">
                        <div class="reco-top-labes">
                            <div class="reco-type-div"><img loading="lazy" src="@/assets/images/icon_-RX-black.svg" alt="" class="reco-type-icon">
                                <div class="text-block-790">Prescricption</div>
                            </div>
                            <div class="reco-category">WEIGHT LOSS</div>
                        </div>
                        <div class="reco-top-summary">
                            <div class="reco-pic-name-div"><img sizes="100vw" srcset="@/assets/images/Tirzepatide-Vial-p-500.png 500w, @/assets/images/Tirzepatide-Vial-p-800.png 800w, @/assets/images/Tirzepatide-Vial.png 1080w" alt="" src="@/assets/images/Tirzepatide-Vial.png" loading="lazy" class="image-443">
                                <div class="reco-name">
                                    <div class="text-block-932">Tirzepatide</div>
                                    <div class="text-block-933">Compound</div>
                                </div>
                            </div>
                            <div class="reco-price-div">
                                <div class="amount-div">
                                    <div class="text-block-934">$</div>
                                    <div class="text-block-935">449</div>
                                </div>
                                <div class="text-block-936">a month</div>
                            </div>
                        </div>
                        <div class="reco-list-div">
                            <div class="reco-list-header">How it could help:</div>
                            <ul role="list" class="list-3">
                                <li>
                                    <div class="reco-list-text">Lose up to 20% body weight in 90 days or less</div>
                                </li>
                                <li>
                                    <div class="reco-list-text">Improve sleep cycle &amp; reduce apnea symptoms</div>
                                </li>
                                <li>
                                    <div class="reco-list-text">Boost daily energy patterns and activity levels</div>
                                </li>
                                <li>
                                    <div class="reco-list-text">Lower blood sugar and cholesterol</div>
                                </li>
                            </ul>
                        </div>
                        <div class="reco-box-bottom-div">
                            <div class="reco-buttons-div">
                                <a href="#" class="reco-button w-button">Learn More</a>
                                <a href="#" class="button-81 w-button">Add to Cart</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="reco-box-div">
                    <div class="portal-reco-box">
                        <div class="reco-top-labes">
                            <div class="reco-type-div"><img loading="lazy" src="@/assets/images/icon_-RX-black.svg" alt="" class="reco-type-icon">
                                <div class="text-block-790">Prescricption</div>
                            </div>
                            <div class="reco-category">WEIGHT LOSS</div>
                        </div>
                        <div class="reco-top-summary">
                            <div class="reco-pic-name-div"><img sizes="100vw" srcset="@/assets/images/Tirzepatide-Vial-p-500.png 500w, @/assets/images/Tirzepatide-Vial-p-800.png 800w, @/assets/images/Tirzepatide-Vial.png 1080w" alt="" src="@/assets/images/Tirzepatide-Vial.png" loading="lazy" class="image-443">
                                <div class="reco-name">
                                    <div class="text-block-932">Tirzepatide</div>
                                    <div class="text-block-933">Compound</div>
                                </div>
                            </div>
                            <div class="reco-price-div">
                                <div class="amount-div">
                                    <div class="text-block-934">$</div>
                                    <div class="text-block-935">449</div>
                                </div>
                                <div class="text-block-936">a month</div>
                            </div>
                        </div>
                        <div class="reco-list-div">
                            <div class="reco-list-header">How it could help:</div>
                            <ul role="list" class="list-3">
                                <li>
                                    <div class="reco-list-text">Lose up to 20% body weight in 90 days or less</div>
                                </li>
                                <li>
                                    <div class="reco-list-text">Improve sleep cycle &amp; reduce apnea symptoms</div>
                                </li>
                                <li>
                                    <div class="reco-list-text">Boost daily energy patterns and activity levels</div>
                                </li>
                                <li>
                                    <div class="reco-list-text">Lower blood sugar and cholesterol</div>
                                </li>
                            </ul>
                        </div>
                        <div class="reco-box-bottom-div">
                            <div class="reco-buttons-div">
                                <a href="#" class="reco-button w-button">Learn More</a>
                                <a href="#" class="button-81 w-button">Add to Cart</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <a href="#" class="portal-content-link w-inline-block">
            <div class="portal-link-image-div"></div>
        </a>
    </div>
    <div class="loading-container" style="margin-top: 50px;" v-if="isLoading">
        <div class="loading-spinner">
            <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="40px" height="40px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" fill="none" stroke="#007bff" stroke-width="8" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                </circle>
            </svg>
        </div>
    </div>

    <div style="height:280px"></div>
</div>
</template>

<script>
import {
    getProductById,
    getProductsByCategory
} from '@/utils/productData'
import progressItems from './progressItems.vue';
import prescriptionWindow from './prescriptionWindow.vue';
import sendDocMessage from './sendDocMessage.vue';
import showImageBox from './showImageBox.vue';
import tostWindow from './tostWindow.vue'

export default {
    name: 'myNewSelf',
    props: {
        baseUrl: {
            type: String,
            required: true
        },
        user: {
            type: Object,
            required: true
        },
    },
    components: {
        progressItems,
        prescriptionWindow,
        sendDocMessage,
        showImageBox,
        tostWindow
    },
    data() {
        return {
            isLoading: true,
            showPres: false,
            messagingOrderModel: false,
            ImageBox: false,
            imageUploadId: '',
            messagingOrderID: '',
            showT: false,
            presText: '',
            progressItems: [],
            openDropdown: null,
            categories: ['MIND', 'BODY', 'WEIGHT', 'SEX', 'LONGEVITY', 'SKIN', 'HAIR'],
            statusOrder: {
                pending_approval: 0,
                appointment_required: 1,
                accepted: 2,
                prescription_received: 3,
                delivered: 4
            },
            steps: [{
                    title: 'Onboarding Questionnaire',
                    description: 'Click Here To Submit.',
                    isLink: true,
                    link_type: 'assesment'
                },
                {
                    title: 'Schedule Appointment',
                    description: 'Click Here to Schedule.',
                    isLink: true,
                    link_type: 'appointment'
                },
                {
                    title: 'Prescription Received',
                    description: 'This is some text inside of a div block.'
                },
                {
                    title: 'Schedule Monthly Follow Up Visit',
                    description: 'This needs to be completed in order to receive your next dosage',
                    dueDate: '12/12/24'
                }
            ]
        }
    },
    computed: {
        recommendedItems() {
            let items = getProductsByCategory('Sex', 1);

            return items;
        }
    },
    methods: {
        async submitMessage(message) {
            const response = await this.$axios.post(`${this.baseUrl}/api/send-doc-message`, {
                message: message,
                visitId: this.messagingOrderID
            });
            if (response.data.status == "success") {
                this.messagingOrderModel = false;
                this.messagingOrderID = '';
                alert("Message sent");
            }
        },
        showSuccessUpload() {
            this.toastMessage = "Image uploaded";
            this.showT = true;
            this.ImageBox = false;
        },
        showImageUpload(id) {
            this.imageUploadId = id;
            this.ImageBox = true;
        },
        showModel(presText) {
            this.presText = presText;
            this.showPres = true;
        },
        showModelMessage(id) {
            this.messagingOrderID = id;
            this.messagingOrderModel = true;
        },
        getCurrentStepIndex(status) {
            return this.statusOrder[status];
        },
        getFullProductName(id) {
            let product = getProductById(id);
            return product[0].name;
        },
        getFullProductImage(id) {
            let product = getProductById(id);
            return product[0].image_pre_text;
        },
        toProperCase(text) {
            return text.toLowerCase()
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
        },
        toggleDropdown(index) {
            this.openDropdown = this.openDropdown === index ? null : index;
        },
        async checkProgressAvailability() {
            try {
                const shouldRefresh = true;

                if (shouldRefresh) {
                    this.isLoading = true;
                    const response = await this.$axios.get(`${this.baseUrl}/api/order-items`);

                    if (response.data.status === 'success') {
                        await this.$store.dispatch('updateProgress', {
                            items: response.data.orders,
                            timestamp: Date.now().toString()
                        });

                        this.progressItems = response.data.orders.sort((a, b) => {
                            return new Date(b.created_at) - new Date(a.created_at);
                        });

                        if (response.data.health_id) {
                            await this.$store.dispatch('updateHealth', {
                                health_id: response.data.health_id
                            });
                        }

                        // Set prescription from latest order
                        const latestPrescription = this.progressItems[0]?.prescription_data || [];
                        this.$store.dispatch('setPrescription', latestPrescription);

                        // Find latest order that is NOT pending_approval
                        const latestValidOrder = this.progressItems.find(order => order.status !== 'pending_approval');

                        if (latestValidOrder) {
                            this.$store.dispatch('setEncounterId', {encounter_id : latestValidOrder.external_visit_id, provider: latestValidOrder.provider});
                        } else {
                            console.warn('No valid order found (excluding pending_approval status)');
                        }

                        // Keep existing setCaseID logic untouched
                        this.$store.dispatch('setCaseID', {
                            id: this.progressItems[0].external_visit_id,
                            provider: this.progressItems[0].provider
                        });
                    }
                } else {
                    this.progressItems = this.$store.getters.progressItems;
                }
            } catch (error) {
                console.error('Failed to fetch progress:', error);
            } finally {
                this.isLoading = false;
            }
        },
        getVisibleSteps(status) {
            const currentIndex = this.statusOrder[status];
            return this.steps.slice(0, currentIndex + 1);
        },
        getStepIcon(stepIndex, itemStatus) {
            const currentStatusIndex = this.statusOrder[itemStatus];

            if (stepIndex < currentStatusIndex) return 'Check-black';
            if (stepIndex === currentStatusIndex) return 'Urgent';
            return 'open';
        }
    },
    mounted() {
        this.checkProgressAvailability();
    }
}
</script>

<style scoped>
.setz {
    z-index: 901 !important;
}

.w-dropdown-list.w--open {
    z-index: 998;
    position: relative;
}
</style>
